import React, { useState } from "react"
import { connect, ConnectedProps } from "react-redux"
import InvoiceStatusSelect from "../../../../src/invoice/statusesselection.component"
import { getAction } from "../../../state/actionlog/actionLogSelector"
import { SelectOption } from "../../../state/helpers/SelectOption"
import InlineGenericEditComponent from "./InlineGenericEditComponent"
import QuoteStatusSelect from "../../../../src/quote/statusesselection.component"
import OrderStatusSelect from "../../../../src/order/statusesselection.component"
import { PROPOSAL_TYPE } from "../../../state/proposal/ProposalType"

type OwnProps = {
    title: string
    name: string
    id: string
    type: string
    value: SelectOption
    options: SelectOption[]
    onChange: (option: SelectOption, actionId: string) => void
}
const InLineStatusSelectComponent = (props: Props) => {
    const [selected, setSelected] = useState<SelectOption>(props.value)
    switch (props.type) {
    case PROPOSAL_TYPE.QUOTE:
        return (
            <>
                <InlineGenericEditComponent
                    valueObject={
                        <label>{props.title}</label>
                    }
                    inputObject={
                        <QuoteStatusSelect
                            name={props.name}
                            id={props.id}
                            value={selected}
                            onChange={setSelected}
                            multi={false}
                            options={props.options}
                        />
                    }
                    action={props.action}
                    onSave={() => props.onChange(selected, props.id)}
                    popupStyle={{ minWidth: "350px" }}
                />
            </>
        )
        // Did not test functionnality 
    case PROPOSAL_TYPE.INVOICE:
        return (
            <>
                <InlineGenericEditComponent
                    valueObject={
                        <label>{selected.label}</label>
                    }
                    inputObject={
                        <InvoiceStatusSelect
                            name={props.name}
                            id={props.id}
                            value={selected}
                            onChange={setSelected}
                            multi={false}
                        />
                    }
                    action={props.action}
                    onSave={() => props.onChange(selected, props.id)}
                    popupStyle={{ minWidth: "350px" }}
                />
            </>
        )
        // Did not test functionnality 
    case PROPOSAL_TYPE.ORDER:
        return (
            <>
                <InlineGenericEditComponent
                    valueObject={
                        <label>{selected.label}</label>
                    }
                    inputObject={
                        <OrderStatusSelect
                            name={props.name}
                            id={props.id}
                            value={selected}
                            onChange={setSelected}
                            multi={false}
                        />
                    }
                    action={props.action}
                    onSave={() => props.onChange(selected, props.id)}
                    popupStyle={{ minWidth: "350px" }}
                />
            </>
        )
    default:
        return (
            <>
                <InlineGenericEditComponent
                    valueObject={
                        <label>{selected.label}</label>
                    }
                    inputObject={
                        <QuoteStatusSelect
                            name={props.name}
                            id={props.id}
                            value={selected}
                            onChange={setSelected}
                            multi={false}
                        />
                    }
                    action={props.action}
                    onSave={() => props.onChange(selected, props.id)}
                    popupStyle={{ minWidth: "350px" }}
                />
            </>
        )

    }
}

const mapState = (state, props: OwnProps) => {
    const action = getAction(state, props.id)
    return { ...props, action: action }
}
const connector = connect(mapState, {})
type Props = ConnectedProps<typeof connector>

export default connector(InLineStatusSelectComponent)


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InLineStatusSelectComponent.tsx